<template>
  <b-modal class="customer-show-payment-mult" ref="modal" :title="dialog_title" hide-footer>
    <div class="row form-group">
      <div class="col-sm-4">
        <input type="datetime-local" v-model="created_at" class="form-control"
          id="customer-show-payment-mult-created-at" required :readonly="!is_editing" />
        <label for="customer-show-payment-mult-created-at" class="wabident-info">Fecha</label>
      </div>

      <div v-if="can_invoice && !is_invoiced" class="col-sm-5">
        <select v-model="invoice_id" id="customer-show-payment-mult-invoice" class="form-control custom-select">
          <option :value="null">Sin factura</option>
          <option v-for="(invoice, index) in filtered_invoices" :key="index" :value="invoice.id">
            {{ invoice.code }}
            <span v-if="invoice.notes"> - {{ invoice.notes }}</span>
          </option>
        </select>
        <label for="customer-show-payment-mult-invoice" class="wabident-info">
          Factura asociada
        </label>
      </div>

      <div class="col-sm-3">
        <select v-model="type" id="customer-show-payment-mult-type" class="form-control custom-select" required
          :disabled="restrict_editing">
          <option :value="null">Seleccionar</option>
          <option value="cash">Efectivo</option>
          <option value="credit_card">Tarjeta</option>
          <option value="transfer">Transferencia</option>
          <option value="mobile">Bizum/Móvil</option>
          <option value="direct_debit">Financiación</option>
          <option v-if="is_core" value="tpv">TPV</option>
          <option v-if="enable_sepa_transfers" value="sepa_tranfer">Recibo (SEPA)</option>
          <option value="other">Otros</option>
        </select>
        <label for="customer-show-payment-mult-type" class="wabident-info">Tipo Cobro</label>
      </div>
    </div>

    <div v-if="enable_payments_v2 && (amount > pending) && !with_deposit" class="row form-group">
      <div class="col">
        <b-alert show variant="warning"><strong>Atención: </strong> Operación con saldo resultante negativo</b-alert>
      </div>
    </div>

    <div v-if="enable_payments_v2 && has_negative_pending" class="row form-group">
      <div class="col">
        <b-alert show variant="danger"><strong>Error: </strong> Tratamientos con sobreasignación de saldo </b-alert>
      </div>
    </div>

    <div class="treatments-summary">
      <div class="row treatments-summary__header">
        <div class="col-sm-6">
          <h6><strong>TRATAMIENTO</strong></h6>
        </div>

        <div class="col-sm-2">
          <h6><strong>PVP</strong></h6>
        </div>
        <div class="col-sm-2">
          <h6><strong>ASIG.</strong></h6>
        </div>
        <div class="col-sm-2">
          <h6><strong>PEND.</strong></h6>
        </div>
      </div>

      <div class="treatments-summary__items">
        <div class="row treatments-summary__item" v-for="treatment in selected_treatments" :key="treatment.id">
          <div class="col-sm-6">
            {{ treatment.full_name }}
          </div>
          <div class="col-sm-2">
            {{ getQuotedPrice(treatment) }}
          </div>
          <div class="col-sm-2">
            {{ getPaidAmount(treatment) }}
          </div>
          <div class="col-sm-2">
            <span style="color:var(--theme-absent);font-weight: bold;" v-if="getPending(treatment) <= 0">
              {{ getPendingAmount(treatment) }}
            </span>
            <span v-else>
              {{ getPendingAmount(treatment) }}
            </span>
          </div>
        </div>
      </div>

      <div class="row treatments-summary__footer-item">
        <div class="col-sm-10">
          <strong>TOTAL A COBRAR:</strong>
        </div>
        <div class="col-sm-2">
          {{ pretty_amount }}
        </div>
      </div>

      <div v-if="enable_payments_v2" class="row treatments-summary__footer-item">
        <div class="col-sm-10">
          <strong>SALDO DISPONIBLE:</strong>
        </div>
        <div class="col-sm-2">
          {{ pretty_pending }}
        </div>
      </div>
    </div>

    <div class="form-group row" v-if="has_multiple_session_treatments">
      <strong>Con los tratamientos de sesión múltiple:</strong>
      <div class="col-sm-12">
        <div class="form-check form-check-inline">
          <input v-model="one_session_only" class="form-check-input" type="checkbox" id="treatment_one_session_only"
            :value="true" />
          <label class="form-check-label" for="treatment_one_session_only">Cobrar sólo una sesión (No se marcará
            realizada
            ni pagada)
          </label>
        </div>
      </div>
    </div>

    <div class="form-group row" v-if="!is_editing && selected_treatments.length">
      <strong>Tras guardar, marcar los tratamientos como:</strong>
      <div class="col-sm-12">

        <div class="form-check form-check-inline">
          <input v-model="is_paid" class="form-check-input" type="checkbox" id="treatment_is_paid" :value="true" />
          <label class="form-check-label" for="treatment_is_paid">Pagados</label>
        </div>

        <div class="form-check form-check-inline">
          <input v-model="is_done" class="form-check-input" type="checkbox" id="treatment_is_done" :value="true" />
          <label class="form-check-label" for="treatment_is_done">Realizados</label>
        </div>

        <div v-if="can_invoice && !invoice_id" class="form-check form-check-inline">
          <input v-model="is_invoiced" class="form-check-input" type="checkbox" id="treatment_is_invoiced"
            :value="true" />
          <label class="form-check-label" for="treatment_is_invoiced">Crear factura única</label>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col buttons-column text-center">
        <button @click="submit" :disabled="is_loading" type="button" class="btn btn-primary btn-wabident">
          <span v-if="is_editing">Modificar</span>
          <span v-else>Crear </span>
          <i v-if="is_loading" class="fa fa-spin fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    customer: { required: true },
    pending: { required: true },
  },
  data() {
    return {
      with_deposit: false,
      payment_id: 0,
      customer_id: 0,
      is_editing: false,
      is_loading: false,
      invoice_id: null,
      created_at: new Date().toISODateTime(),
      type: "cash",
      notes: "",
      vat: null,
      is_paid: false,
      is_done: false,
      is_invoiced: false,
      one_session_only: false,
      selected_treatments: [],
      selected_treatment: null,
      available_invoices: null,
    };
  },
  watch: {
    one_session_only() {
      this.$forceUpdate();
    },
  },
  computed: {
    has_negative_pending() {
      const negatives = this.selected_treatments.filter((t) => {
        return this.getPending(t) <= 0;
      });

      return negatives.length > 0;
    },
    enable_sepa_transfers() {
      return this.clinic && this.clinic.config.payments_enable_sepa_transfers;
    },
    can_invoice() {
      return this.clinic && !this.clinic.config.disable_invoices;
    },
    has_multiple_session_treatments() {
      return this.selected_treatments.reduce((acc, current) => {
        return acc || (current.max_sessions > 1);
      }, false);
    },
    amount() {
      let amount = 0;
      this.selected_treatments.forEach((t) => {
        const divider = this.one_session_only ? t.max_sessions : 1;
        if (divider > 1) {
          amount += t.session_price;
        } else {
          amount += (t.quoted_price - t.paid_amount);
        }
      });
      return amount;
    },
    default_is_invoiced() {
      if (!this.clinic) return false;
      return this.clinic.config['payments_auto_invoice'] || false;
    },
    pretty_amount() {
      return WabiDent.fmtMoney(this.amount);
    },
    pretty_pending() {
      return WabiDent.fmtMoney(this.pending);
    },
    is_dental() {
      if (!this.clinic) return true;
      return this.clinic.type == "dental";
    },
    is_aesthetic() {
      return !this.is_dental;
    },
    restrict_editing() {
      false;
    },
    dialog_title() {
      return 'Pagar Tratamientos';
    },
    filtered_invoices() {
      if (!this.available_invoices) return [];
      // Filter invoices. Non deposit invoices cannot be assigned to downpayments
      return this.available_invoices.filter((invoice) => {
        if (this.with_deposit) {
          return invoice.is_downpayment;
        }
        return !invoice.is_downpayment;
      });
    },
    enable_payments_v2() {
      return this.clinic && this.clinic.config.enable_payments_v2;
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic", "is_core"]),
  },
  methods: {
    getPending(treatment) {
      const paid = treatment.paid_amount || 0;
      const quoted = treatment.quoted_price || 0;
      return quoted - paid;
    },
    getPendingAmount(treatment) {
      return window.WabiDent.fmtMoney(this.getPending(treatment));
    },
    getPaidAmount(treatment) {
      if (!treatment.paid_amount) {
        return "";
      }
      return window.WabiDent.fmtMoney(treatment.paid_amount);
    },
    getQuotedPrice(treatment) {
      if (!treatment.quoted_price) {
        return "";
      }
      const divider = this.one_session_only ? Math.max(treatment.max_sessions, 1) : 1;
      return window.WabiDent.fmtMoney(treatment.quoted_price / divider);
    },
    showNewTreatments(treatments, invoices = null, with_deposit = null) {
      this.one_session_only = false;
      this.selected_treatments = treatments;
      this.with_deposit = with_deposit;
      this.payment_id = 0;
      this.customer_id = this.customer ? this.customer.id : 0;
      this.is_editing = false;
      this.type = null;

      if (invoices && invoices.length == 1) {
        this.invoice_id = invoices[0].id;
      } else {
        this.invoice_id = null;
      }

      let names = treatments.map((t) => {
        let r = t.product.name;
        if (t.teeth && t.teeth.length > 0) {
          this.notes += " (" + t.teeth.join(",") + ")";
        }
        return r;
      });

      this.notes = "Pago tratamientos: " + names.join(", ");
      this.vat = null;
      this.is_paid = true;
      this.is_done = true;
      this.is_invoiced = this.default_is_invoiced;
      this.created_at = new Date().toISODateTime();

      this.$refs.modal.show();
      this.updateInvoices();
    },
    updateInvoices() {
      axios
        .get(`/customer/${this.customer_id}/invoices_payment`)
        .then((response) => {
          this.available_invoices = response.data;
          this.$forceUpdate();
        })
        .catch((err) => {
          this.msgwindow.error("Error obteniendo facturas");
        });
    },
    submit() {
      if (this.has_negative_pending) {

        let bad_treatments = [];
        this.selected_treatments.forEach((t) => {
          if (this.getPending(t) <= 0) {
            bad_treatments.push(t.full_name);
          }
        });

        const lines = [
          '<div><b>Atención:</b></div>',
          '<p>Los siguientes tratamientos ya tienen demasiado saldo asignado<p>',
          bad_treatments.join('<br>'),
          '<p>Tendrás que resolver los pagos manualmente</p>',
        ];

        this.errorwindow.show('Error', lines.join(''), 'Aceptar');
        return;
      }

      if (!this.validatePayment()) return;

      if (!this.is_editing) {
        let message = "¿Confirmar creación?";
        message += "<br>No podrás deshacer esta operación";

        this.errorwindow.show(
          "Confirmación",
          message,
          "Crear",
          "Cancelar",
          () => {
            this.addPayment();
          }
        );
      } else {
        this.updatePayment();
      }
    },
    validatePayment() {
      let errors = [];

      if (!this.type) {
        errors.push(
          "<li>Debes seleccionar un Tipo: Efectivo, Tarjeta, etc ..."
        );
      }

      if (!this.amount) {
        errors.push("<li>Debes indicar una Cantidad mínima");
      }

      if (!this.notes) {
        errors.push("<li>Debes indicar el Concepto");
      }

      if (this.type == "cash" && this.amount > 1000) {
        errors.push("<li>No puedes ingresar Efectivo superior a 1000€");
      }

      if (
        this.clinic.type != "dental" &&
        this.vat == null &&
        this.selected_treatments.length == 0
      ) {
        errors.push(
          "<li>Debes elegir al menos un tratamiento o un tipo de IVA a aplicar"
        );
      }

      if (errors.length) {
        let message = "<ul>" + errors.join() + "</ul>";
        this.errorwindow.show("Error", "No se puede crear el cobro:" + message);
        return false;
      }

      return true;
    },
    addPayment() {
      if (!this.is_loading) {
        this.is_loading = true;

        var params = {
          amount: this.amount,
          notes: this.notes,
          type: this.type,
          clinic_id: this.clinic ? this.clinic.id : null,
          invoice_id: this.invoice_id,
          created_at: this.created_at,
          treatments: this.selected_treatments.map((x) => {
            return x.id;
          }),
          is_paid: this.is_paid,
          is_done: this.is_done,
          is_invoiced: this.is_invoiced,
          one_session_only: this.one_session_only ? 1 : 0,
          with_deposit: this.with_deposit ? 1 : 0,
          vat: this.vat,
        };

        axios
          .post(`/customer/${this.customer.id}/payment`, params)
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Añadido con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            this.msgwindow.error("Error añadiendo!");
            this.$refs.modal.hide();
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
  },
  mounted() { },
};
</script>

<style lang="scss">
.treatments-summary {
  background-color: var(--theme-grey-bg);
  padding: 10px;
  margin: 15px 0;

  &__items {
    margin: 5px 0;
    padding: 5px 0;
    border-top: 1px var(--theme-grey) solid;
    border-bottom: 1px var(--theme-grey) solid;
  }
}
</style>
